export const networking = {
  'fullProfile': 'Pilnas profilis',
  'QrBadge': 'QR ženklelis',
  'myNetwork': 'Mano tinklas',
  'seeAll': 'Peržiūrėti visus',
  'newcommers': 'Nauji tinklo nariai',
  'checkThemOut': 'Pažiūrėkite juos!',
  'activities': 'Veiklos',
  'topicsToDiscuss': 'Temos diskusijoms',
  'OneOnOneMeet': '1:1 susitikimas',
  'leaderboard': 'Reitingų lentelė',
  'learnMoreNetworking': 'Sužinokite daugiau apie Networking Hub',
  'scanQrCode': 'Nuskaityti QR kodą',
  'myBadge': 'Mano ženklelis',
  'scannedBadge': 'Nuskaitytas ženklelis',
  'viewProfile': 'Peržiūrėti profilį',
  'message': 'Žinutė',
  'userRatingDetails': 'Naudotojo reitingo informacija',
  'networkingHub': 'Networking Hub',
  'totalScore': 'Bendras taškų skaičius:',
  'scoreComposedOf': 'Šis balas susideda iš:',
  'confirmationText': 'Ar tikrai? Šio veiksmo nebus galima atšaukti.',
  'discussionTopic': 'Diskusijos tema',
  'notes': 'Pastabos',

  'welcomeMessage': 'Sveiki atvykę į <strong>Networking Hub</strong>, kur gimsta ryšiai! Štai kaip tai veikia:',
  'connectingMadeSimpleTitle': 'Ryšių užmezgimas paprastas',
  'connectingMadeSimpleDescription': 'Networking Hub siūlo struktūrizuotas veiklas ir lygius, padedančius efektyviai bendrauti:',

  'newcomersDescription':
    '<strong>Nauji nariai:</strong> Tyrinėkite naujų narių profilius, pasirinkite įdomius ir siųskite žinutes. Galite net susisiekti asmeniškai.',
  'shortlistDescription': '<strong>Pasirinkimas:</strong> Kai parodote susidomėjimą, jie pridedami prie jūsų sąrašo.',
  'contactedConnectedDescription':
    '<strong>Susisiekta/Prisijungta:</strong> Kai susisiekiate ir gaunate atsakymą, jie patenka į šias grupes.',
  'skipDescription': '<strong>Praleisti:</strong> Nesidomite? Tiesiog praleiskite profilį ir tęskite!',

  'enhancedNetworkingActivitiesTitle': 'Išplėstos networking veiklos',
  'enhancedNetworkingActivitiesDescription': 'Be tiesioginių ryšių, Hub siūlo:',

  'topicsToDiscussDescription':
    '<strong>Diskusijų temos:</strong> Tyrinėkite jus dominančias temas ir susisiekite su autoriais ar dalyviais. Dalyvaukite internetinėse diskusijose arba suplanuokite grupinius susitikimus gilinti temas.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 susitikimų planuoklis:</strong> Valdykite susitikimų užklausas, sekite suplanuotus susitikimus ir lengvai organizuokite savo tvarkaraštį.',

  'gamificationTitle': 'Žaidybinimas dėl smagumo ir įsitraukimo',
  'gamificationDescription':
    'Padidinkite savo aktyvumą su reitingų lentele, kuri seka jūsų taškus ir išryškina aktyviausius tinklo narius. Taškus galite uždirbti taip:',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1000 taškų:</strong> Užpildykite savo profilį (įskaitant nuotrauką).',
    points1000PushNotifications: '<strong>1000 taškų:</strong> Įjunkite push pranešimus.',
    points100SendMeetingRequest: '<strong>100 taškų:</strong> Siųskite 1:1 susitikimo užklausą.',
    points400GetAcceptedRequest: '<strong>400 taškų:</strong> Jūsų 1:1 užklausa priimta.',
    points400AcceptRequest: '<strong>400 taškų:</strong> Priimkite 1:1 užklausą.',
    points100DeclineRequest: '<strong>100 taškų:</strong> Atmesti 1:1 užklausą.',
    points400CreateDiscussion: '<strong>400 taškų:</strong> Sukurkite diskusijos temą.',
    points50LikeDiscussion: '<strong>50 taškų:</strong> Patinka diskusijos tema.',
    points200PostFirstComment: '<strong>200 taškų:</strong> Paskelbkite pirmą komentarą kitoje temoje.',
    points100LikeOnTopic: '<strong>100 taškų:</strong> Gaukite patinka savo temai.',
    points200UniqueCommenter: '<strong>200 taškų:</strong> Gaukite unikalų komentatorių savo temai.',
    points100LikeShortlistUser: '<strong>100 taškų:</strong> Patinka / pasirinkite vartotoją (pridėkite prie sąrašo).',
    points50SkipUser: '<strong>50 taškų:</strong> Praleiskite vartotoją.',
    points200StartChat: '<strong>200 taškų:</strong> Pradėkite pokalbį (susisiekta).',
    points300GetChatResponse: '<strong>300 taškų:</strong> Gaukite atsakymą pokalbyje (prisijungta).',
    points400RespondToChat: '<strong>400 taškų:</strong> Atsakykite į pokalbio užklausą (prisijungta).',
    points500SpeedNetworking: '<strong>500 taškų:</strong> Už kiekvieną greito networking sesiją.'
  },

  'finalMessage':
    'Išnaudokite visas Networking Hub galimybes, atraskite naujų progų ir lipkite reitingų lentelėje bendraudami su panašiai mąstančiais profesionalais!',

  'manageMeeting': 'Valdyti susitikimą',
  'addToCalendar': 'Pridėti prie kalendoriaus',
  'cancel': 'Atšaukti',
  'accept': 'Priimti',
  'accept&addToCalendar': 'Priimti ir pridėti prie kalendoriaus',
  'editDetails': 'Redaguoti detales',
  'reject': 'Atmesti',
  'delete': 'Ištrinti',
  'exportContact': 'Eksportuoti kontaktą',
  'scheduleNewOneOnOne': 'Suplanuoti naują 1:1',
  'initiatedBy': 'Pradėjo',
  'rejectedBy': 'Atmetė',
  'you': 'jūs',
  'meetPassed': 'Susitikimas įvyko',
  'meetInProgress': 'Vyksta',

  'myOneOnOne': 'Mano 1:1',

  'speed': {
    history: 'Istorija',
    minutes: 'minutės',
    users_available: 'pasiekiami',
    rules: 'Taisyklės',
    activate: 'Aktyvuoti',
    matching: 'Suderinama...',
    start: 'Pradėti',
    find_a_user: 'Raskite vartotoją su ta pačia nuotrauka',
    find_a_user_number: 'Raskite vartotoją su ta pačia numeracija',
    waiting: 'Laukiama...',
    speaking_now: 'Dabar kalba',
    networking_topics: 'Networking temos',
    session_ended: 'Sesija baigėsi',
    find_next_partner: 'Raskite kitą partnerį',
    find_next_group: 'Raskite kitą grupę',
    partner_wasnt_ready: 'Partneris nebuvo pasiruošęs',
    partner_wasnt_ready_description: 'Atrodo, kad partneris nebuvo pasiruošęs diskusijai. Raskime naują!',
    start_matching: 'Pradėti suderinimą'
  }
}
